exports.data = JSON.parse(`{
  "results": [
      {
          "id": 1,
          "name": "United States Dollar",
          "code": "USD",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 2,
          "name": "Canadian Dollar",
          "code": "CAD",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 3,
          "name": "British Pound Sterling",
          "code": "GBP",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 4,
          "name": "Euro",
          "code": "EUR",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 5,
          "name": "Australian Dollar",
          "code": "AUD",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 6,
          "name": "Brazilian Real",
          "code": "BRL",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 7,
          "name": "Russian Ruble",
          "code": "RUB",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 8,
          "name": "Ukrainian Hryvnia",
          "code": "UAH",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 9,
          "name": "Swedish Krona",
          "code": "SEK",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 10,
          "name": "Norwegian Krone",
          "code": "NOK",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 11,
          "name": "Turkish Lira",
          "code": "TRY",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 12,
          "name": "Polish Zloty",
          "code": "PLN",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 13,
          "name": "Danish Krone",
          "code": "DKK",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 14,
          "name": "Japanese Yen",
          "code": "JPY",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 15,
          "name": "South Korean Won",
          "code": "KRW",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 16,
          "name": "Singapore Dollar",
          "code": "SGD",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 17,
          "name": "Costa Rican Colón",
          "code": "CRC",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 18,
          "name": "Mexican Peso",
          "code": "MXN",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 19,
          "name": "Kazakhstani Tenge",
          "code": "KZT",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 20,
          "name": "South African Rand",
          "code": "ZAR",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 21,
          "name": "New Zealand Dollar",
          "code": "NZD",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 22,
          "name": "Ghanaian Cedi",
          "code": "GHS",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 23,
          "name": "Colombian Peso",
          "code": "COP",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 24,
          "name": "Bermudan Dollar",
          "code": "BMD",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 25,
          "name": "Philippine Peso",
          "code": "PHP",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 26,
          "name": "Guatemalan Quetzal",
          "code": "GTQ",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 27,
          "name": "Hong Kong Dollar",
          "code": "HKD",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 28,
          "name": "New Taiwan Dollar",
          "code": "TWD",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 29,
          "name": "Turkish Lira",
          "code": "TRL",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 30,
          "name": "Malaysian Ringgit",
          "code": "MYR",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 31,
          "name": "Thai Baht",
          "code": "THB",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 32,
          "name": "Indian Rupee",
          "code": "INR",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 33,
          "name": "Swiss Franc",
          "code": "CHF",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 34,
          "name": "Israeli New Shekel",
          "code": "ILS",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      },
      {
          "id": 35,
          "name": "Emirati Dirham",
          "code": "AED",
          "is_enabled": true,
          "created_at": "2020-08-24T15:53:07.000000Z",
          "updated_at": "2020-08-24T15:53:07.000000Z"
      }
  ],
  "count": 35
}`)
